import React, {Component}        from 'react';
import {connect}                 from 'react-redux';
import {Field, reduxForm, reset} from 'redux-form';
import {SetComentarioPost}       from '../../../actions/grupoAction';
import validate                  from '../../../service/validate_nave';
import renderField                from '../../../container/renderField';

class Equipe_Aluno_renderComentarioPost_Form extends Component {

    constructor(props){

        super(props);
        this.state = {
                        equ_pos_id     : this.props.equ_pos_id,
                        use_id         : this.props.use_id,
                     }
     
    }

    handleSubmit(e) {

        this.props.SetComentarioPost(this.state,e.comentario);
   }

   render() {

          const {handleSubmit} = this.props;   
        return (
            <div>
                <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                    <div className="input-group">
                        <Field 
                            name        = "comentario"
                            type        = "text"
                            component   = {renderField}
                            placeholder = "Escreva um comentário..."
                            label       = ""
                        />     
                        <span className="input-group-btn">
                            <button
                                className = "btn btn-default"
                                type      = "submit"
                                onClick   = {this.setComentarioPost}>
                                <span className="glyphicon glyphicon-send" aria-hidden="true"></span>
                            </button>
                        </span>
                    </div>
                </form>
            </div>
        )
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('comentario_turma'));

export default reduxForm({
   form                     : 'comentario_turma', //                 <------ same form name
   destroyOnUnmount         : true, //        <------ preserve form data
   forceUnregisterOnUnmount : true, // <------ unregister fields on unmount
   onSubmitSuccess          : afterSubmit,
  validate
})(connect(null,{SetComentarioPost})(Equipe_Aluno_renderComentarioPost_Form));




// WEBPACK FOOTER //
// ./src/components/professor/timeline_equipe/equipe_aluno_comentario_post_form.js